import * as React from 'react';
import { BaseModel } from './BaseModel';

interface IUserModelProps {
    id: string;
    UniqueId: string;
    UserId: number;
    Job_Title: string;
    Regions: string[];
    Access_Level: string;
    Last_Name: string;
    Job_Desc: string;
    Last_Updated: string;
    Date_Created: string;
    Middle_Name: string;
    PlantIds: string[];
    First_Name: string;
    Email: string;
}

export class UserModel extends BaseModel<IUserModelProps> {
    constructor(props: IUserModelProps) {
        super(props);
    }

    static resource = 'user';
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/model/UserModel.tsx